import { render, staticRenderFns } from "./bulk.vue?vue&type=template&id=0329a18d&scoped=true&"
import script from "./bulk.vue?vue&type=script&lang=js&"
export * from "./bulk.vue?vue&type=script&lang=js&"
import style0 from "./bulk.vue?vue&type=style&index=0&id=0329a18d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0329a18d",
  null
  
)

export default component.exports